import { getTranslatedRefNumberDisplayName as coreGetTranslatedRefNumberDisplayName } from '@nova/core';
import { useWarehouseSettings } from '@satellite/composables/useWarehouseSettings';

/**
 * Helios façade over satellite {@link useWarehouseSettings}.
 *
 * Adds Helios-specific semantic helpers on top of the generic setting reader.
 * Hierarchy (warehouse → org → schema defaults) is on by default — matching
 * legacy GET /warehouse/:id consolidated settings.
 *
 * @param {import('vue').MaybeRefOrGetter<WarehouseDetails | null | undefined>} warehouse
 * @param {import('@satellite/composables/useWarehouseSettings').UseWarehouseSettingsOptions} [options]
 */
export function useSelectedWarehouseSettings(warehouse, options = {}) {
  // TODO: (welington) remove `warehouse` param once warehouse state is truly global cross-modules.

  const { rawSettings, consolidatedSettings, getSettingValue } = useWarehouseSettings(
    warehouse,
    options
  );

  const isMilitaryTimeEnabled = (helperOptions = null) =>
    getSettingValue('enableMilitaryTime', helperOptions) === true;

  const isRescheduleByCarrierForbidden = (helperOptions = null) =>
    getSettingValue('rescheduleByCarrierForbidden', helperOptions) === true;

  const getTranslatedRefNumberDisplayName = (helperOptions = null) =>
    coreGetTranslatedRefNumberDisplayName(
      getSettingValue('referenceNumberDisplayName', helperOptions)
    );

  return {
    rawSettings,
    consolidatedSettings,
    getSettingValue,
    getTranslatedRefNumberDisplayName,
    isMilitaryTimeEnabled,
    isRescheduleByCarrierForbidden
  };
}

/**
 * @typedef {import('@satellite/composables/useWarehousesPresenter').WarehouseDetails} WarehouseDetails
 */
